import { fmt, type UiStrings } from '@/constants/ui-locale'
import type { BacklogSyncTally } from '../utils/backlogTally'

/**
 * What the push did, under the table (BRAI-575).
 *
 * Amber while anything is still waiting on the reviewer and quiet once it is
 * not: the bar's job is to say whether the job is finished, and a row left
 * unconfirmed is the one way a push can look done without being done.
 *
 * @param tally Counts from {@link tallySync}.
 */
export default function BacklogSyncSummaryBar({
  tally,
  t,
}: {
  tally: BacklogSyncTally
  t: UiStrings
}) {
  const waiting = tally.needsConfirm > 0

  return (
    <div
      className={[
        'mt-3 flex flex-wrap items-center justify-between gap-2 rounded-xl border px-4 py-2.5 text-xs',
        waiting
          ? 'border-amber-300 bg-amber-50/50 text-amber-800 dark:border-amber-500/40 dark:bg-amber-500/5 dark:text-amber-300'
          : 'border-[var(--border-color)] bg-[var(--bg-secondary)] text-[var(--text-secondary)]',
      ].join(' ')}
    >
      <span className={waiting ? 'font-semibold' : ''}>
        {fmt(t.backlogSummaryBar, {
          created: tally.created,
          updated: tally.updated,
          confirm: tally.needsConfirm,
          skipped: tally.skipped,
          duplicate: tally.duplicate,
          failed: tally.failed,
        })}
      </span>
      <span>
        {waiting && tally.firstPending !== null
          ? fmt(t.backlogSummaryRemaining, { number: String(tally.firstPending).padStart(2, '0') })
          : t.backlogSummaryDone}
      </span>
    </div>
  )
}
